import React, { useState } from 'react';
import { FlexHeader } from './components/FlexHeader';
import { Layout, HorizontalGroup } from '@libs/uikit/Components';
import './index.css';
import { TagGenerator } from './components/TagGenerator';
import { Integration } from './components/options/integration';
import { AdvertisementBars } from './components/options/AdvertisementBars';
import { AdSpot } from './components/AdSpot';
import { Preview } from './components/Preview';
import { HeaderBidding } from './components/headerBidding/HeaderBidding';
import { StyledColumn } from './components/StyledColumn';
import { StyledMain } from './components/StyledMain';
import { TopHorizontalGroup } from './components/TopHorizontalGroup';
import { FlexFooter } from './components/FlexFooter';

const App = (props) => {
    const [advertisementBars, setAdBars] = useState(true);
    const [activeTab, setActiveTab] = useState(props.activeTab);
    const [hoveredPreview, setHoveredPreview] = useState(null);
    const [headerBidding, setHeaderBidding] = useState(false);
    const [urls, setUrls] = useState([{ url: '', isPortrait: false, hasError: false }]);
    const [adUnits, setAdUnits] = useState(props.adUnits);
    const isActive = headerBidding;

    return (
        <Layout>
            <FlexHeader />
            <TopHorizontalGroup>
                <StyledColumn>
                    <StyledMain>
                        <HorizontalGroup style={{ marginTop: 0, marginBottom: 0 }}>
                            <Integration activeTab={activeTab} selectTab={setActiveTab} />
                            <AdvertisementBars
                                active={advertisementBars}
                                onClick={setAdBars}
                                onOver={setHoveredPreview}
                            />
                        </HorizontalGroup>
                    </StyledMain>

                    <StyledMain>
                        <AdSpot
                            adUnits={adUnits}
                            select={setAdUnits}
                            activeTab={activeTab}
                            onOver={setHoveredPreview}
                        />
                    </StyledMain>

                    {activeTab !== 'SAFE FRAME' && (
                        <HeaderBidding
                            isActive={isActive}
                            urls={urls}
                            switchInputState={setHeaderBidding}
                            update={setUrls}
                        />
                    )}
                </StyledColumn>

                {hoveredPreview && <Preview src={hoveredPreview} />}

                <StyledColumn>
                    <StyledMain>
                        <TagGenerator
                            adUnits={adUnits}
                            activeTab={activeTab}
                            urls={urls}
                            advertisementBars={advertisementBars}
                            headerBidding={headerBidding}
                        />
                    </StyledMain>
                </StyledColumn>
            </TopHorizontalGroup>
            <FlexFooter />
        </Layout>
    );
};

export default App;
